import type { Feature } from '@luna/gatekeeper';

export const cardInsurance: Feature = {
    enabled: true,
    _description: 'Enables the payment protection insurance feature',
};
